// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/light-bootstrap-dashboard.scss
// module id = /4dZ
// module chunks = 1